@if (isProducerArea) {
  <div class="sidebar" [ngClass]="{ collapsed: isCollapsed || navBarMode, 'nav-bar-mode': navBarMode }">
    <ul class="nav flex-column list-group list-group-flush gap-2" [ngClass]="{ 'ps-4 pe-4': !isCollapsed }">
      @if (!isCollapsed) {
        <li class="nav-item">
          <a class="nav-link sidebar-title">Pessoal</a>
        </li>
      }
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/my-orders')"
        title="Meus Ingressos">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/my-orders">
          <i class="pi pi-ticket" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Meus ingressos
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/my-invitations')"
        title="Meus Ingressos">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/my-invitations">
          <i class="pi pi-gift" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Meus convites
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/favorite-events')"
        title="Eventos favoritos">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/favorite-events">
          <i class="pi pi-sparkles" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Eventos favoritos
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/followed-producers')"
        title="Produtores seguidos">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/followed-producers">
          <i class="pi pi-users" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Produtores seguidos
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/notifications')"
        title="Notificações">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/notifications">
          <span class="sidebar__notification-icon">
            <i class="pi pi-bell" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
            @if (notificationStore.unreadCount() > 0) {
              <span class="sidebar__badge">
                {{ notificationStore.unreadCount() > 99 ? "99+" : notificationStore.unreadCount() }}
              </span>
            }
          </span>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Notificações
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/support')"
        title="Ajuda">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/support">
          <i class="pi pi-comments" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">Ajuda</p>
        </a>
      </li>
      <div *appHasRole="['organizer']">
        @if (isProducerArea && !isCollapsed) {
          <li class="nav-item">
            <a class="nav-link sidebar-title"> Área do produtor</a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/producer-area', true)"
            title="Área do produtor">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/producer-area">
              <i class="pi pi-chart-bar" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Resumo geral
              </p>
            </a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/create-event')"
            title="Criar evento">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/create-event">
              <i class="pi pi-plus" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Criar evento
              </p>
            </a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/my-events')"
            title="Meus eventos">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/my-events">
              <i class="pi pi-calendar" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Meus eventos
              </p>
            </a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/my-page')"
            title="Minha página">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/my-page">
              <i class="pi pi-home" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Minha página
              </p>
            </a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/wallet')"
            title="Carteira">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/wallet">
              <i class="pi pi-wallet" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Carteira
              </p>
            </a>
          </li>
        }
        @if (isProducerArea) {
          <li
            class="nav-item list-group-item list-group-item-action bg-transparent p-2"
            [class.sidebar__active]="isActive('/solicitations')"
            title="Solicitações">
            <a
              class="nav-link d-flex align-items-center gap-2 p-0"
              [ngClass]="{ 'flex-column': isCollapsed }"
              routerLink="/solicitations">
              <i class="pi pi-list-check" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
              <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
                Solicitações
              </p>
            </a>
          </li>
        }
      </div>
      @if (!isCollapsed) {
        <li class="nav-item">
          <a class="nav-link sidebar-title">Conta</a>
        </li>
      }
      <li class="nav-item list-group-item list-group-item-action bg-transparent p-2">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          (click)="openModalSignUp()"
          title="Meu cadastro">
          <i class="pi pi-address-book" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Meu cadastro
          </p>
        </a>
      </li>
      <li
        class="nav-item list-group-item list-group-item-action bg-transparent p-2"
        [class.sidebar__active]="isActive('/my-cards')"
        title="Meus cartões">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          routerLink="/my-cards">
          <i class="pi pi-credit-card" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">
            Meus cartões
          </p>
        </a>
      </li>
      <li class="nav-item list-group-item list-group-item-action bg-transparent p-2" title="Sair">
        <a
          class="nav-link d-flex align-items-center gap-2 p-0"
          [ngClass]="{ 'flex-column': isCollapsed }"
          (click)="logout()">
          <i class="pi pi-sign-out" [ngClass]="{ 'font-size-x-large': isCollapsed }"></i>
          <p class="p d-flex align-items-center m-0 p-0" [ngClass]="{ 'font-size-x-small': isCollapsed }">Sair</p>
        </a>
      </li>
      @if (!navBarMode) {
        <li
          class="nav-item list-group-item list-group-item-action bg-transparent d-flex justify-content-center sidebar__toggle"
          (click)="toggleSidebar()"
          title="Esconder / Mostrar barra lateral">
          <i class="pi" [ngClass]="{ 'pi-chevron-right': isCollapsed, 'pi-chevron-left': !isCollapsed }"></i>
        </li>
      }
    </ul>
  </div>
}
